import { FormSetting } from '@/form-settings/form-setting';
import { ControlBase } from '@components/dynamic-form/control-base';
import { ControlType } from '@components/dynamic-form/control-type';
import { DateControl } from '@components/dynamic-form/date-control';

export class MSDiscountDuplicateFormSetting extends FormSetting {
  protected static classToCall: string;
  private static rows: ControlBase[] = [];

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    this.rows = [];

    this.addRowMonthYearFrom();
    this.addRowMonthYearTo();
    this.addBrand();

    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  private static addBrand() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'marca';
    inputsComponent.label = 'Marca';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.disabled = true;
    inputsComponent.class = 'w-3/12';
    inputsComponent.isObject = true;
    inputsComponent.objectKeys = ['codiceMarca', 'descrizioneMarca'];
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowMonthYearFrom() {
    const inputsComponent = {} as DateControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'yearMonthFrom';
    inputsComponent.controlType = ControlType.monthYearDate;
    inputsComponent.label = 'Da mese/anno';
    inputsComponent.class = 'w-3/12';
    inputsComponent.maxDateToday = true;
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowMonthYearTo() {
    const inputsComponent = {} as DateControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'yearMonthTo';
    inputsComponent.controlType = ControlType.monthYearDate;
    inputsComponent.label = 'Su nuovo mese/anno';
    inputsComponent.class = 'w-3/12';
    inputsComponent.maxDateToday = true;
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }
}
